import React from 'react';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';
import { DropdownComponent } from '../../../../../components/prime-formik';

const SuperProfileRequiredManagementExperience = () => {
  const { setFieldValue } = useFormikContext();

  const requiredManagementExperienceOptions = [
    { label: 'None', value: 'NONE' },
    { label: 'Manager', value: 'MANAGER' },
    { label: 'Team leader experience', value: 'TEAM_LEADER_EXPERIENCE' },
    { label: 'Leadership experience', value: 'LEADERSHIP_EXPERIENCE' },
  ];

  return (
    <div className="p-col-12">
      <div className="flex-space-between">
        <FormattedMessage
          id="account.super-profiles.new.required-management-experience"
          defaultMessage="Required management/leadership experience"
        >
          {(text) => (
            <label className="field-label" htmlFor="requiredManagementExperience">
              {text}
            </label>
          )}
        </FormattedMessage>
        <FormattedMessage id="select" defaultMessage="Select">
          {(text) => (
            <Field
              id="requiredManagementExperience"
              name="requiredManagementExperience"
              component={DropdownComponent}
              options={requiredManagementExperienceOptions}
              filter
              filterBy="label,value"
              className="right"
              onChange={(event) => {
                setFieldValue('requiredManagementExperience', event.value);
              }}
              placeholder={`-- ${text} --`}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
};

export default SuperProfileRequiredManagementExperience;
